/* eslint-disable no-mixed-spaces-and-tabs,no-tabs */

xplenty.filter('prettydate', [
  function () {
    return function (dateString) {
      return moment(dateString).fromNow();
    };
  },
]);
